export class DeviceUtils {
  static isMobile (): boolean {
    return /Mobi|Android/i.test(navigator.userAgent)
  }
}
